<style src="./Editor.scss" lang="scss"></style>

<template lang="pug">
  form.editor(
    :class='{ "is-loading": loading }'
    enctype="multipart/form-data"
  )
    .editor__header
      .editor__cover
        Cover(
          type='tracks'
          :cover='track.cover'
        )

      .editor__fields
        .editor__field
          Input(
            name='name'
            :placeholder='$l10n("TRACK_NAME")'
            :required='true'
            v-model='form.title'
            @input='debounced.update'
          )
</template>

<script>
import { mapActions } from "vuex";

import Cover from "@/components/Cover/Cover";
import Input from "@/components/Input/Input";
import Icon from "@/components/Icon/Icon";
import Button from "@/components/Button/Button";

import editorMixin from "@/mixins/components/editor.mixin";
import helpers from "@/services/helpers";

export default {
  props: {
    track: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      debounced: {
        update: null
      },
      form: {
        title: this.track.title
      }
    };
  },
  components: {
    Cover,
    Input,
    Icon,
    Button
  },
  mixins: [editorMixin],
  methods: {
    ...mapActions({
      updateTrack: "tracks/update"
    }),
    update() {
      this.updateTrack({
        id: this.track.id,
        title: this.form.title || this.$l10n("NO_NAME")
      });
    }
  },
  created() {
    this.debounced.update = helpers.debounce(() => {
      this.update();
    }, 1000);
  }
};
</script>
